import { createReducer } from "reduxsauce";
import ReducerRegister from "../../ReducerRegister";
import AsyncActionReducers from "../../AsyncActionReducers";
import { ActionTypes } from "../../actionTypes/screens/homework/NewDefaultActionTypes";
import NewDefaultService from "../../../services/screens/homework/NewDefaultService";
// import { ActionTypes as ReviewUnitActionTypes } from "../../actionTypes/screens/homework/ReviewUnitActionTypes";
// import { ActionTypes as HistoryActionTypes } from "../../actionTypes/screens/homework/HomeworkHistoryActionTypes";
// import { Actions as OfflineStorageActions, ActionTypes as OfflineStorageActionTypes } from "../../actionTypes/utils/OfflineStorageActionTypes";
import UIDs from "../../../UIDs";
// import { ActionTypes as SettingActionTypes } from "../../actionTypes/screens/me/ProfileSettingActionTypes";
// import { ActionTypes as NotificationActionTypes } from "../../actionTypes/NotificationActionTypes";
// import * as HomeworkHelper from "../../../utils/HomeworkHelper";
import _ from "lodash";
import StoreManager from "../../index";
import * as HomeworkHelper from "../../../utils/HomeworkHelper";
import DebugLogger from "../../../../utils/DebugLogger";
// import OfflineStorageHelper from "../../../utils/OfflineStorageHelper";

//
// Actions
//
const loadScreenView = (successCallback, failureCallback) => {
    NewDefaultService.loadScreenView(
        response => {
            let { newHomeworks } = response;
            if (newHomeworks.length > 0) {
                let homeworkId = newHomeworks[0].homeworkId;
                HomeworkHelper.loadData(
                    homeworkId,
                    () => {
                        newHomeworks[0].download = true;
                        if (successCallback) {
                            successCallback(response);
                        }
                    },
                    error => {
                        // if (failureCallback) {
                        //     failureCallback(error);
                        // }
                        DebugLogger.log(error);
                        if (successCallback) {
                            successCallback(response);
                        }
                    },
                );
            } else {
                if (successCallback) {
                    successCallback(response);
                }
            }
        },
        error => {
            if (failureCallback) {
                failureCallback(error);
            }
        },
    );
};

const Actions = {
    loadScreenViewAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            loadScreenView(
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                },
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error,
    }),

    loadHomeworkData: homeworkId => ({
        type: ActionTypes.LOAD_HOMEWORK_DATA,
        homeworkId,
    }),

    updateScreenInBackgroundAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_ASYNC });

            loadScreenView(
                response => {
                    dispatch(Actions.updateScreenInBackgroundSuccess(response));
                },
                error => {
                    dispatch(Actions.updateScreenInBackgroundFailure(error));
                },
            );
        };
    },

    updateScreenInBackgroundSuccess: data => ({
        type: ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_SUCCESS,
        parentType: ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
    }),

    updateScreenInBackgroundFailure: error => ({
        type: ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_FAILURE,
        parentType: ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_ASYNC,
        postReducer: updateScreenInBackgroundFailurePostReducer,
        error,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    user: null,
    latestClass: null,
    newHomeworks: [],
    replyCount: 0,
    reviewCount: 0,
    peerReviseCount: 0,
    receivedHomeworkId: "",
    receivedUserHomeworkId: "",
    needUpdateInBackground: false,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    const { user, latestClass, newHomeworks, replyCount, reviewCount, peerReviseCount } = data;
    return { ...state, user, latestClass, newHomeworks, replyCount, reviewCount, peerReviseCount, needUpdateInBackground: false };
};

const updateScreenInBackgroundFailurePostReducer = (state, { error }) => {
    return { ...state, needUpdateInBackground: false };
};

const loadHomeworkDataReducer = (state, { homeworkId }) => {
    let cloneNewHomeworks = _.cloneDeep(state.newHomeworks);
    cloneNewHomeworks.forEach(h => {
        if (h.homeworkId === homeworkId) {
            h.download = true;
        }
    });
    return { ...state, newHomeworks: cloneNewHomeworks };
};

// const replyUnitReducer = (state, { unit }) => {
//     let replyCount = state.replyCount;
//     replyCount -= 1;
//     let reviewCount = state.reviewCount;
//     if (Number(unit.score) < HomeworkHelper.unitPassingScore(unit) && !unit.reviewedOn) {
//         reviewCount += 1;
//     }
//     return { ...state, replyCount, reviewCount };
// };
//
// const reviewUnitReducer = (state, {  }) => {
//     let reviewCount = state.reviewCount;
//     reviewCount -= 1;
//     return { ...state, reviewCount };
// };
//
// const reviewUnitRestartReducer = (state, {  }) => {
//     let reviewCount = state.reviewCount;
//     reviewCount += 1;
//     return { ...state, reviewCount };
// };
//
// const receivedNewAssignmentReducer = (state, { data }) => {
//     let newHomeworks = _.cloneDeep(state.newHomeworks);
//     let receivedHomeworkId = "";
//     let receivedUserHomeworkId = "";
//     if (newHomeworks.every(u => u.userHomeworkId !== data.userHomeworkId && u.homeworkAssignmentId !== data.homeworkAssignmentId)) {
//         newHomeworks.unshift(data);
//         receivedHomeworkId = data.homeworkId;
//         receivedUserHomeworkId = data.userHomeworkId;
//     }
//     return { ...state, newHomeworks, receivedHomeworkId, receivedUserHomeworkId };
// }
//
// const receivedNewReplyReducer = (state, { data }) => {
//     let { replyCount = 0, reviewCount = 0 } = data;
//     return { ...state, replyCount, reviewCount };
// }
//
// const receivedAssignmentRecallReducer = (state, { data }) => {
//     let newHomeworks = Array.from(state.newHomeworks);
//     let idx = newHomeworks.findIndex(u => u.userHomeworkId === data.userHomeworkId);
//     if (idx > -1) {
//         newHomeworks.splice(idx, 1);
//     }
//     return { ...state, newHomeworks };
// }
//
// const receivedNewClassReducer = (state, { data }) => {
//     return { ...state, latestClass: data };
// }
//
// const receivedRemoveFromClassReducer = (state, { data }) => {
//     let classUserHomeworks = Array.from(data);
//     let newHomeworks = Array.from(state.newHomeworks);
//     classUserHomeworks.forEach(userHomeworkId => {
//         let idx = newHomeworks.findIndex(u => u.userHomeworkId === userHomeworkId);
//         if (idx > -1) {
//             newHomeworks.splice(idx, 1);
//         }
//     })
//     return { ...state, newHomeworks };
// }
//
// const updateUserPhotoReducer = (state, { newPhoto }) => {
//     var newUser = { ...state.user };
//     newUser.icon.isUseAvatar = false;
//     newUser.icon.photo = newPhoto;
//     return { ...state, user: newUser };
// };
//
// const updateUserNameReducer = (state, { data, firstName, lastName }) => {
//     var newUser = { ...state.user };
//     newUser.firstName = firstName;
//     newUser.lastName = lastName;
//     newUser.icon.avatarName = Helper.getAvatarStr(firstName);
//     return { ...state, user: newUser };
// };
//
// const appBecomeActiveReducer = state => {
//     return { ...state, needUpdateInBackground: true };
// };

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    // [ReviewUnitActionTypes.REVIEW_UNIT_SUCCESS]: reviewUnitReducer,
    // [ReviewUnitActionTypes.RESTART_UNIT]: reviewUnitRestartReducer,
    // [HistoryActionTypes.REPLY_UNIT_SUCCESS]: replyUnitReducer,
    // [NotificationActionTypes.RECEIVED_NEW_ASSIGNMENT]: receivedNewAssignmentReducer,
    // [NotificationActionTypes.RECEIVED_NEW_REPLY]: receivedNewReplyReducer,
    // [NotificationActionTypes.RECEIVED_ASSIGNMENT_RECALL]: receivedAssignmentRecallReducer,
    // [NotificationActionTypes.RECEIVED_NEW_CLASS]: receivedNewClassReducer,
    // [NotificationActionTypes.RECEIVED_REMOVE_FROM_CLASS]: receivedRemoveFromClassReducer,
    // [NotificationActionTypes.APP_BECOME_ACTIVE]: appBecomeActiveReducer,
    // [SettingActionTypes.CHANGE_MEMBER_PHOTO_SUCCESS]: updateUserPhotoReducer,
    // [SettingActionTypes.CHANGE_NAME_SUCCESS]: updateUserNameReducer,
    // [OfflineStorageActionTypes.LOAD_HOMEWORK_DATA_SUCCESS]: loadHomeworkDataReducer,
    [ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.homework.newdefault, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
